<script setup lang="ts">
const props = defineProps<{
    isOpen: boolean;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
}>();

const emit = defineEmits(['close', 'confirm']);
</script>

<template>
    <div v-if="isOpen" class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.5); z-index: 1050;" @click.self="emit('close')">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pb-0">
                    <h5 class="modal-title fw-bold">{{ title }}</h5>
                    <button type="button" class="btn-close" @click="emit('close')"></button>
                </div>
                <div class="modal-body py-4">
                    <p class="mb-0 text-muted">{{ message }}</p>
                </div>
                <div class="modal-footer border-0 pt-0">
                    <button type="button" class="btn btn-light rounded-pill px-4" @click="emit('close')">
                        {{ cancelText || 'Annuler' }}
                    </button>
                    <button type="button" class="btn btn-danger rounded-pill px-4" @click="emit('confirm')">
                        {{ confirmText || 'Confirmer' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
